/**
 * DESERTLAND.Content.Tips
 */
import { Utils } from '../cals.utils';
import { App, initStickySubnav } from '../desertland.app';
import { ROUTES } from '../desertland.router';
import { Masonry } from '../cals.masonry';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.layout';
// import 'kendo-ui-core/js/kendo.template';
import 'kendo-ui-core/js/kendo.tabstrip';

declare var log, info, warn, group, groupCollapsed, groupEnd;

// require("kendo.tabstrip");
//require("");//TODO: require bootstrap.collapse

const USETABS = false;


export class TipsContent {

  public showLogs = true;
  public invasivesItemTitle = "Problem Plants".toLowerCase(); //where to inject the invasives photos

  public page = ROUTES.TIPS;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-tips';
  // public contentWrap = "#tips_content_container";
  public contentContainer = "#tips_content_container .page-content";
  public tabSel = 'tips_tabstrip';
  public indexSel = 'tips_index_container';
  public indexTransSel = 'tips_index_trans';
  public footNavSel = 'tips_footnav_container';
  public invasivesReady = false;

  public route = '';

  public init(options) {
    groupCollapsed("Tips.init");
    let showLogs = this.showLogs;

    if (showLogs) { log(this.page + ".init", options); }

    if (!options) {
      options = "";
    }
    this.route = options;

    //get invasives https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/invasives.json
    if (App.data.invasives && App.data.invasives.length > 0) {
      if (showLogs) { info("invasives data ready", App.data.invasives); }
      this.invasivesReady = true;
    } else {
      if (showLogs) { info("invasives data not ready yet", App.data.invasives); }
      this.invasivesReady = false;
      // DESERTLAND.radio('dataInvasivesReady').subscribe([App.content.Tips.onInvasivesDataReady, App.content.Tips]);
      App.service.load.invasives((data) => {
        //if (showLogs) { log("invasives loaded, listening to radio..."); }
        this.onInvasivesDataReady(data);
        // DESERTLAND.radio('dataInvasivesReady').broadcast(data).unsubscribe(App.content.Tips.onInvasivesDataReady);
      });
    }

    if ($(this.container).length) {
      if (showLogs) { log("ready for " + this.page); }
      this.loadTpl(this.renderTpl);
    } else {
      $(() => {
        if (showLogs) { info(this.page + " dom ready! loadTpl..."); }
        if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
          this.loadTpl(this.renderTpl);
        }

      });
    }
    groupEnd("Tips.init");
  }


  public onRoute(options) {
    if (this.showLogs) { info(this.page + " > route", options); }
    if (!options) {
      options = "index";
    }
    this.route = options;
    //this.init();
    this.showRoute();
  }

  public showRoute(options = {}) {
    //info("showRoute",options);
    if (this.route) {
      if (this.showLogs) { info("there's a route", this.route); }
      let opt = this.route.split("/");
      if (this.showLogs) { info('showRoute', opt); }
      if (opt && opt.length > 0) {
        if (opt[0] === 'index') {
          this.showIndex();
        }
        let $tab = $(".tips-tab-nav-" + opt[0]);
        if ($tab.length) {
          this.activateTab($tab, opt[0]);

          if (opt.length > 1) {
            //info(opt[1]);
            let btnSel = '.btn-tip-' + opt[0] + '-' + opt[1];
            window.setTimeout(function () { // need a delay to await the tpls loaded and faded in to get good offset top #

              if ($(btnSel).length) {

                $(btnSel).click();
              }
            }, 420);

          }
        }
      }
    }
  }


  public loadTpl(callback) {
    if (this.showLogs) { log(this.page + " > loadTpl"); }
    if ($(this.tplSel).length) {
      if (this.showLogs) { log("// we already have the tpl"); }
      this.renderTpl({ sel: this.tplSel });
    } else {
      App.templates.loadLayout(this.page, this.tplSel, this.renderTpl);
    }

  }

  public renderTpl = (resp) => {
    $(document).ready(() => {
      if (this.showLogs) { log(this.page + " > renderContent", resp); }
      if (resp && resp.sel && $(resp.sel).length) {
        //log($(resp.sel));
        let layout = new kendo.Layout($('#'+resp.tag).html(), { model: App.models.pageView.viewModel });
        $(this.container).empty();
        layout.render($(this.container));
  
        this.loadContent(this.formatThenRender);
  
      } else {
        if (this.showLogs) { info("no sel?"); }
      }
    });
  }

  public loadContent(callback) {

    if (App.data.tips) {
      if (this.showLogs) { log("data exists, using"); }
      this.renderContent(App.data.tips);
    } else {
      App.service.load.tips(callback);
    }
  }

  public formatThenRender = (tips_desc, tips) => {
    groupCollapsed("Tips.Render");
    // let me = App.content.Tips; // in a callback
    if (this.showLogs) { info("tips_desc: %o tips: %o", tips_desc, tips); }
    let formatted = this.formatData(tips, tips_desc);
    App.data.tips = formatted;
    this.renderContent(formatted);
    groupEnd("Tips.Render");
  }

  public formatData(tips, tips_desc) {
    //info(tips, tips_desc);
    let catNum = 1,
      cats = [],
      tip_cats = {},
      data_length = tips.length,
      findCat = function (tid) {
        return tips_desc.find(function (c) {
          //info(tid, c);
          // return (c.tip_group && catGroup) ? c.tip_group.toLowerCase() === catGroup.toLowerCase() : false;
          return (c.tid && tid) ? c.tid === tid : false;
        });
      };
    for (let i = 0; i < data_length; i++) {
      if (!Utils.isEmpty(tips[i].tid)) {//tip_group)) {
        //if (this.showLogs) { log(tips[i]); }
        let this_cat = tips[i].tid;//tip_group;
        cats.pushIfNotExist(this_cat);
        if (!Utils.objectHasProperty(tip_cats, this_cat)) {
          let foundCat = findCat(this_cat);
          let catDesc = "Click More to read about this.";
          if (foundCat && foundCat.tip_desc) {
            //info(foundCat.tip_desc);
            catDesc = foundCat.tip_desc;
          }
          tip_cats[this_cat] = {
            cat_name: foundCat.tip_group,
            desc: catDesc,
            cat_num: catNum,
            items: []
          };
          catNum++;
        }
        tip_cats[this_cat].items.push(tips[i]);
      }
    }

    let oRet = {
      tip_cats: cats,
      tips: tip_cats,
      item_count: data_length
    };

    if (this.showLogs) { info("Tips > formatData ret: %o", oRet); }
    return oRet;
  }

  public renderContent(data) {
    if (this.showLogs) { log("Tips > renderContent %o", data); }

    if ($("#tips.page").length && $(this.contentContainer).length) {


      this.renderIndex(data);

      // sticky subnav - the sticky lib is probably already called?
      //var $sticky = $("#sticky_subnav");


      // load content section
      let $container = $(this.contentContainer).hide().empty();
      if ($("#" + this.footNavSel).length) {
        $("#" + this.footNavSel).empty();
      }

      this.renderTabs(data, $container);
      // for (var i = 0; i < data.tip_cats.length; i++) {
      //     this.renderCategory(data.tips[data.tip_cats[i]],$container, i + 1);
      // }


      this.addEvents();

      $container.fadeIn();

      this.showRoute();//if route is found

    } else {
      info("!#tips.page || !container");
    }
  }

  public renderIndex(data) {
    //tips_index_container
    if (this.showLogs) { log("Tips > renderIndex %o", data); }
    let $container = $("#" + this.indexSel);//.hide().empty();

    if ($container.length && data.tip_cats.length > 0) {
      $container.hide().empty();

      let $row = $(document.createElement("div")).addClass('row').appendTo($container);

      for (let i = 0; i < data.tip_cats.length; i++) {
        this.renderIndexItem(data.tips[data.tip_cats[i]], $row);//, i + 1);
      }

      $container.fadeIn();
    }
  }

  public renderIndexItem(data, $container) {
    if (this.showLogs) { log("Tips > renderIndexItem %o", data); }

    let catName = Utils.changeSpacesToDashes(data.cat_name).toLowerCase();

    let tplStr = '<div class="col-sm-6">'
      + '<div class="tips-cat-num-circle circle text-center white">#= cat_num #</div>'
      + '<div class="content-nav-block bg-black-trans text-center">'
      + '<h3 class="nav-block-title">#= cat_name #</h3>'
      + '<div class="nav-block-desc">#= desc #</div>'
      + '<div class="nav-block-action"><a href="/\\#/' + ROUTES.TIPS + '/' + catName + '" class="btn btn-outlined action__show-tab" data-tab="' + catName + '">More</a></div>'
      + '</div>'
      + '</div>';

    let template = kendo.template(tplStr);
    let result = template(data);
    $container.append(result);

  }


  // renderNav (data) {
  //     log("Tips > renderNav",data);
  //     var $container = $("#tips_sticky_nav");//.hide().empty();

  //     if ($container.length) {
  //         $container.hide().empty();

  //         for (var i = 0; i < data.tip_cats.length; i++) {
  //             this.renderNavItem(data.tips[data.tip_cats[i]],$container, i + 1);
  //         }

  //         $("#tabstrip").kendoTabStrip({
  //             animation:  {
  //                 open: {
  //                     effects: "fadeIn"
  //                 }
  //             }
  //         });

  //         $container.fadeIn();
  //     }


  // },
  // renderNavItem (data, $container, cat_num) {
  //     log("Tips > renderNavItem",data);
  //     var catName = Utils.changeSpacesToDashes(data.cat_name);
  //     $("<a></a>").attr({
  //             href: '#' + catName,
  //             title: data.cat_name
  //         }).addClass("nav-circle").html(cat_num ).appendTo($container);
  // },

  public renderHeadNavItem(cat, $container) { //replace the kendo tabstrip
    if (this.showLogs) { log("Tips > renderHeadNavItem %o", cat); }
    // var $container = $("#" + this.footNavSel);
    if ($container.length) {
      let catName = Utils.changeSpacesToDashes(cat.cat_name),
        css = catName.toLowerCase();
      $(document.createElement("li")).attr({
        'data-cat': css,
        'data-tab': css,
        'title': cat.cat_name
      }).addClass("circle circle-tab-nav k-link action__tab-nav-foot tips-tab-nav-" + css).html(cat.cat_num).appendTo($container);
    }
  }

  public renderFootNavItem(cat) {
    if (this.showLogs) { log("Tips > renderFootNavItem %o", cat); }
    let $container = $("#" + this.footNavSel);
    if ($container.length) {
      let catName = Utils.changeSpacesToDashes(cat.cat_name),
        css = catName.toLowerCase();
      $(document.createElement("li")).attr({
        'data-cat': css,
        'data-tab': css,
        'title': cat.cat_name
      }).addClass("circle circle-tab-nav k-link action__tab-nav-foot tips-tab-nav-" + css).html(cat.cat_num).appendTo($container);
    }
  }


  public renderTabs(data, $container) {
    if (this.showLogs) { log("Tips > renderTabNav %o", data); }

    //tips_content_container
     // trying to stretch across page instead of container
    //  let $topnav = $(document.createElement("ul")).addClass("tips-tab-nav-top-list list-unstyled");//.appendTo($(document.createElement("div")).addClass("tips-list-tab-nav-top").appendTo($container));
    //  if ($(this.contentWrap).length) {
    //    $topnav.appendTo($(document.createElement("div")).addClass("tips-list-tab-nav-top").appendTo($(this.contentWrap)));
    //  }

    if ($container.length) {
      // hack in top tab nav overwrite
      let $topnav = $(document.createElement("ul")).addClass("tips-tab-nav-top-list list-unstyled").appendTo($(document.createElement("div")).addClass("tips-list-tab-nav-top").appendTo($container));

      let $tabstrip = $(document.createElement("div")).attr({ id: this.tabSel }).appendTo($container);


      let $ul = $(document.createElement("ul")).addClass("tips-list-tab-nav").appendTo($tabstrip);
      for (let i = 0; i < data.tip_cats.length; i++) {
        let cat = data.tips[data.tip_cats[i]],
          css = Utils.changeSpacesToDashes(cat.cat_name).toLowerCase();
        $(document.createElement("li")).attr({
          'data-cat': css,
          'title': cat.cat_name
        }).addClass("circle circle-tab-nav action__tab-nav tips-tab-nav-" + css).html(cat.cat_num).appendTo($ul);
        this.renderTabCategory(cat, $tabstrip);

        this.renderFootNavItem(cat);
        this.renderHeadNavItem(cat, $topnav);
      }

      $tabstrip.kendoTabStrip({
        animation: {
          open: {
            effects: "fadeIn"
          }
        },
        // Note: Invoking the activateTab method will not trigger any events ...f'ers- http://docs.telerik.com/kendo-ui/api/javascript/ui/tabstrip#methods-activateTab

        activate: App.content.Tips.onTabActivate,//function(e) {
        //     // access the activated item via e.item (Element)   
        // e.item Element - The activated tab.
        // e.contentElement Element - The content element of the activated tab
        //     info("activate -> hideIndex",e.item);
        //     App.content.Tips.hideIndex();
        //     App.content.Tips.onActivate(e);
        // },
        show(e) {
          // access the shown item via e.item (Element)
          info("kendoTabStrip show", e.item);
          // detach show event handler via unbind()
          // $tabStrip.unbind("show", onShow);
        },
        select(e) {
          // access the shown item via e.item (Element)
          info("kendoTabStrip select", e.item);
          // detach show event handler via unbind()
          // $tabStrip.unbind("show", onShow);
        }
      });
    }
  }

  public onTabActivate(e) { // never gets called... // Note: Invoking this method will not trigger any events ...f'ers- http://docs.telerik.com/kendo-ui/api/javascript/ui/tabstrip#methods-activateTab
    //KendoTabStrip event handler
    // access the activated item via e.item (Element)   
    info("kendoTabStrip > onActivate -> hideIndex item: %o e:%o", e.item, e);
    App.content.Tips.hideIndex();
  }

  public renderTabCategory(data, $container) {
    if (this.showLogs) { log("Tips > renderTabCategory %o", data); }

    if ($container.length) {
      let catName = Utils.changeSpacesToDashes(data.cat_name).toLowerCase();
      let $div = $(document.createElement("div")).addClass("tips-list-tab-content tips-list-tab-" + catName).appendTo($container);
      this.renderCategory(data, $div, catName, data.cat_num);
    }
  }


  public renderCategory(data, $container, catName, catNum) {
    if ($container.length) {
      // var catName = Utils.changeSpacesToDashes(data.cat_name).toLowerCase();

      // data.cat_num

      // $("<a></a>").attr({
      //     id: catName,
      //     name: catName,
      //     class: 'anchor'
      // }).appendTo($container);

      let $subNav = $("<div></div>").attr({
        id: 'tips-item-nav-' + catName
      }).addClass('tip-tab-item-nav item-nav-' + catName)
        .append($("<h3></h3>").attr({
          id: 'tip-section-title-' + catName
        }).addClass('tip-section-title container limit-width').html(data.cat_name)) //col-xs-12
        .append($("<div></div>").addClass('tip-section-desc container limit-width').html(data.desc))
        .appendTo($container);
      let $subnavItems = $(document.createElement('div')).addClass("container limit-width tab-subnav-items tips-subnav-sticky-" + catName).appendTo($subNav);
      let itemsHtml = this.renderItems(data.items, catName, catNum, $subnavItems);
      $("<div></div>").addClass("tip-items").html(itemsHtml).appendTo($container);



    }

  }

  public renderItems(items, catName, catNum, $subNav) {
    let html = '';
    for (let i = 0; i < items.length; i++) {
      items[i].grp = catName;
      items[i].grpNum = catNum;
      html += this.renderItem(items[i], $subNav, i);
    }
    html += '';
    return html;
  }

  public renderItem(item, $subNav, index) {
    let imgs = "",
      imgAlts = [];

    //info(item);

    // INVASIVES
    let invasiveImgs = "";
    //info(item.title.toLowerCase() , this.invasivesItemTitle);
    if (item.title.toLowerCase() === this.invasivesItemTitle) { //initially "problem plants"
      group("Tips.Render.Invasives");
      if (this.showLogs) { info("render invasives", item); }

      invasiveImgs += this.renderInvasives();

      //info("rendered: ", invasiveImgs);
      groupEnd("Tips.Render.Invasives");
    }
    imgs += invasiveImgs;


    if (item && item.image_alt) {
      imgAlts = item.image_alt.split('|') || [];
    }
    //log(imgAlts);

    if (item && item.image) {
      item.image.split('|').forEach(function (x, i) {
        imgs += '<div class="tip-img"><img src="'
          + App.config.img_url.tips + x
          + '" class="tip-image"';
        if (imgAlts.length >= i + 1) {
          imgs += ' alt="' + imgAlts[i] + '"';
          imgs += ' />';
          imgs += '<div class="caption">' + imgAlts[i] + '</div>';
        } else {
          imgs += ' />';
        }
        imgs += '</div>';
      });

    }

    let itemSubsHtml = "",
      itemSubDesc = [];
    if (item && item.subtip_description) {
      itemSubDesc = item.subtip_description.split('|') || [];
    }
    if (item && item.subtip_title) {
      item.subtip_title.split('|').forEach(function (title, i) {
        if (itemSubDesc.length >= i + 1) {
          // then there's a desc and title, add it
          let subsel = Utils.changeSpacesToDashes(Utils.removeSpecialChars(title)).toLowerCase(),
            subtipid = 'subtip-collapse_' + subsel;
          let collapse = '<div id="' + subtipid + '" class="collapse"><div class="desc">' + itemSubDesc[i] + '</div></div>',
            caret = '<span class="caret icon-indicator"></span>',
            btn = '<button class="btn-green btn-collapse" type="button" data-toggle="collapse" data-target="#' + subtipid + '" aria-expanded="false" aria-controls="' + subtipid + '">' + title + caret + '</button>';

          itemSubsHtml += '<div class="tip-subtip">' + btn + collapse + '</div>';
        } else {
          log("there's a title but not desc... doing nothing for title: %s", item.subtip_title);
        }
      });
      if (itemSubsHtml) {
        itemSubsHtml = '<div class="tip-subtips">' + itemSubsHtml + '</div>';
      }
    }



    let tit = Utils.changeSpacesToDashes(Utils.removeSpecialChars(item.title)).toLowerCase(),
      elid = 'tip-' + Utils.removeSpecialChars(item.grp) + '-' + tit;

    //info(index);
    let btnSel = 'btn-' + elid,
      firstClass = USETABS ? " collapsed" : "",
      inClass = "",
      ariaExp = 'false';
    if (index === 0) {

      if (USETABS) { // if bootstrap collapse
        firstClass = "";
        inClass = " in";
        ariaExp = 'true';
      } else {
        firstClass = " active";
      }
    }


    // create subnav btn
    if (USETABS) {// if bootstrap collapse
      $("<div></div>").addClass('tip-tab-item-nav-item ') //col-xs-12 col-sm-6 col-md-4
        .append($("<a></a>").attr({
          //'id' : btnId,
          'role': 'button',
          'data-toggle': 'collapse',
          //'data-parent' : '.tips-item-nav-' + item.grp,//"#" + this.tabSel + "-" + item.grpNum, 
          'aria-expanded': ariaExp,
          'aria-controls': elid,
          'href': '#' + elid,
          'data-nav': '/#/' + ROUTES.TIPS + '/' + item.grp + '/' + tit
        }).addClass('tip-tab-item-nav-btn ' + btnSel + ' btn btn-orange ' + firstClass).html(item.title))
        .append($("<a></a>").attr({
          //'id' : btnId,
          'role': 'button',
          'href': '#' + elid,
          'data-nav': '/#/' + ROUTES.TIPS + '/' + item.grp + '/' + tit
        }).addClass('tip-tab-item-nav-btn ' + btnSel + ' btn btn-orange ' + firstClass).html(item.title))
        .appendTo($subNav);
    } else {
      // else anchors (no bootstrap collapse)
      $("<div></div>").addClass('tip-tab-item-nav-item ') //col-xs-12 col-sm-6 col-md-4
        .append($("<a></a>").attr({
          //'id' : btnId,
          'role': 'button',
          'data-anchor': '#' + elid,
          'data-nav': '/#/' + ROUTES.TIPS + '/' + item.grp + '/' + tit,
          'href': '/#/' + ROUTES.TIPS + '/' + item.grp + '/' + tit
        }).addClass('tip-tab-item-nav-btn ' + btnSel + ' btn btn-orange ' + firstClass).html(item.title))//end else
        .appendTo($subNav);
    }


    $("." + btnSel).click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      //log("click",btnSel);
      $(".tip-tab-item-nav-btn").removeClass("active");
      //$(this).addClass("active");
      $("." + btnSel).addClass("active");

      let nav = $(this).attr('data-nav');
      //log("click",nav);
      if (nav && window.history && window.history.pushState) {
        let stateObj = { nav };
        window.history.pushState(stateObj, "Tips : " + item.tip_group + " : " + item.title + "Desert Landscaping ", nav);
      }

      if (USETABS) {// if bootstrap collapse
        // $(this).removeClass("collapsed");

        let target = $(this).data("target");
        //log('click target: ',target);
        let acpanels: any = $('.tips-list-tab-' + item.grp).find(".collapse.in").not(target);
        //log('.tips-list-tab-' + item.grp, acpanels);
        if (acpanels && typeof acpanels.collapse === "function") {
          acpanels.collapse("hide");
          //$(target).collapse("show");
        } else {
          info("why nota collapse? ... ", 'click target: ', target, '.tips-list-tab-' + item.grp, acpanels);
        }
      } else {
        let anchor = $($(this).attr('data-anchor'));
        if (anchor.length) {
          //info(anchor);
          let scrollTo = $(anchor).offset().top,
            callback = null;//function(e) {log("done scrolling");};
          Utils.smoothScrollTo("offsetNav", callback, scrollTo);
        } else {
          info("anchor not found?", $(this).attr('data-anchor'));
        }

      }
    });




    let html = '';
    if (USETABS) {// if bootstrap collapse
      html += '<div class="collapse' + inClass + '" id="' + elid + '">';
    } else {
      html += '<section class="tip-item' + inClass + '" id="' + elid + '">'
        + '<h3 class="tip-title">' + item.title + '</h3>'
        + '<div class="tip-content">' + item.description + '</div>'
        + '<div class="tip-images clearfix">' + imgs + '</div>'
        + itemSubsHtml
        + '</section>';
    }


    return html;
  }


  public onInvasivesDataReady(data) {
    //if (this.showLogs) { log("onInvasivesDataReady", App.data.invasives); }
    App.data.invasives = data;
    this.invasivesReady = true;
    //this.renderInvasives();
  }

  public renderInvasives() {

    let html = "";
    if (App.data.invasives) {
      if (this.showLogs) { info("renderInvasives", App.data.invasives); }


      let data = App.data.invasives;

      if (data.length > 0) {
        data.forEach(function (item, i) {

          /**
           *  botanical_name
              common_name
              image
              image_alt
              problem
              family
              location
              form
              size
              origin
              elimination
              garden
              regulation
              nid
           */

          let itemHtml = '<div class="tip-img tip-img-invasive">',
            img = "",
            imgAlt = "";

          if (item.image) {
            img = App.config.img_url.invasive + item.image.split('|')[0];
          }
          if (item.image_alt) {
            imgAlt = item.image_alt.split('|')[0];
          } else {
            imgAlt = "Invasive Plant : Desert Landscaping";
          }

          if (img) {
            itemHtml += '<img src="' + img + '" class="tip-image" alt="' + imgAlt + '" />';
          }

          itemHtml += '<div class="caption"><dl>';

          if (item.common_name) {
            itemHtml += '<dt class="common-name">Common Name</label></dt><dd>' + item.common_name + '</dd>';
          }
          if (item.botanical_name) {
            itemHtml += '<dt class="botanical-name">Botanical Name</label></dt><dd>' + item.botanical_name + '</dd>';
          }
          if (item.problem) {
            itemHtml += '<dt class="problem">Problem</label></dt><dd>' + item.problem + '</dd>';
          }
          if (item.family) {
            itemHtml += '<dt class="family">Family</label></dt><dd>' + item.family + '</dd>';
          }
          if (item.location) {
            itemHtml += '<dt class="location">Where Found</label></dt><dd>' + item.location + '</dd>';
          }
          if (item.form) {
            itemHtml += '<dt class="form">Where Found</label></dt><dd>' + item.form + '</dd>';
          }
          if (item.size) {
            itemHtml += '<dt class="size">Size</label></dt><dd>' + item.size + '</dd>';
          }
          if (item.origin) {
            itemHtml += '<dt class="origin">Origin</label></dt><dd>' + item.origin + '</dd>';
          }
          if (item.elimination) {
            itemHtml += '<dt class="elimination">How to Eliminate</label></dt><dd>' + item.elimination + '</dd>';
          }
          if (item.garden) {
            itemHtml += '<dt class="garden">Use in Garden</label></dt><dd>' + item.garden + '</dd>';
          }
          if (item.regulation) {
            itemHtml += '<dt class="regulation hidden">Regulation</label></dt><dd class="hidden">' + item.regulation + '</dd>';
          }


          itemHtml += '</dl></div>';//caption
          itemHtml += '</div>';//tip-img

          html += itemHtml;
        });

      }
      return html;
    } else {
      info("renderInvasives > No Invasive Data?");
    }
  }



  public activateTab($tab, cat) {
    let me = App.content.Tips;
    if (this.showLogs) { info("activate tab", cat); }
    this.hideIndex();

    if ($tab.length) {
      $('#' + this.tabSel).kendoTabStrip().data("kendoTabStrip").activateTab($tab);
    }

    // highlight active tabs
    // remove any current active .circle-tab-nav
    $("[class*='tips-tab-nav-']").removeClass('active');

    // update all tab circles matching page 
    let circleSel = '.circle-tab-nav.tips-tab-nav-' + cat;
    if ($(circleSel).length) {
      $(circleSel).addClass('active');
    }

    //update bottom circle nav too
    // //info($tab);
    // if ($('#' + this.footNavSel).length && $tab.selector && $($tab.selector).length) {//&& $('.tips-tab-nav-foot').length 
    //   $("[class*='tips-tab-nav-']").removeClass('active');
    //   $($tab.selector).addClass('active');
    // }


    //info(cat);
    if (cat) {
      let sel = '.tips-subnav-sticky-' + cat;
      if ($(sel).length) {
        this.updateStickySubnav(sel);
        // DESERTLAND.initStickySubnav(sel);
        // this.addEventStickySubnavClones();
      } else {
        if (this.showLogs) { info("sel not found", sel); }
      }
    } else {
      if (this.showLogs) { info("no cat sent..."); }
      // scroll to top
      // Utils.smoothScrollTo('top');
    }

    // MASONRY
    /* function makeMasonry(sel, itemSel, colWidth) {
            if args are undefined, set to the default (tips)
            sel = sel || '.tip-images';
            itemSel = itemSel || '.tip-img';
            colWidth = colWidth || 370; */
    //window.setTimeout(CB.makeMasonry, 600);
    // window.setTimeout(Masonry.makeMasonry(".tips-list-tab-" + cat + ' .tip-images'), 600);
    let masonry = new Masonry();
    window.setTimeout(function () {
      masonry.makeMasonry(".tips-list-tab-" + cat + ' .tip-images');
      Utils.smoothScrollTo('top');
    }, 600);

  }

  public deactivateTab($tab) {
    if ($tab.length) {
      $('#' + App.content.Tips.tabSel).kendoTabStrip().data("kendoTabStrip").deactivateTab($tab);
    }
    App.content.Tips.showIndex();

    //update bottom circle nav too
    if ($("[class*='tips-tab-nav-']").length) {
      $("[class*='tips-tab-nav-']").removeClass('active');
    }
  }


  public hideIndex() {
    //info("hideIndex",this.indexTransSel);
    if (("#" + this.indexTransSel).length) {
      $("#" + this.indexTransSel).addClass("minimize");
    }
    if (("#" + this.footNavSel).length) {
      $("#" + this.footNavSel).removeClass("minimize");
    }
  }

  public showIndex() {
    //info("showIndex",this.indexTransSel);
    if (("#" + this.indexTransSel).length) {
      $("#" + this.indexTransSel).removeClass("minimize");
    }
    if (("#" + this.footNavSel).length) {
      $("#" + this.footNavSel).addClass("minimize");
    }
    Utils.smoothScrollTo('top');
  }


  public onClickTipsTopNav = () => {
    // let me = App.content.Tips;
    if (this.showLogs) { log('topnav:click:tips'); }
    if (App.currentPage === this.page) {
      if (this.showLogs) { info("we're on the tips page"); }
      this.showIndex();
    } else {
      // if (this.showLogs) { info("nada thx"); }
    }

  }

  public addEvents() {
    let sel = '.action__show-tab',
      me = this;
    if (this.showLogs) { info('tips > addEvents'); }
    App.radio.unsubscribe('topnav:click:tips', this.onClickTipsTopNav);
    App.radio.subscribe('topnav:click:tips', this.onClickTipsTopNav);


    if ($(sel).length) {
      $(sel).off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        let tab = $(this).attr("data-tab"),
          $tab = $(".tips-tab-nav-" + tab);

        let nav = $(this).attr('href');
        if (me.showLogs) { log("click", nav, $(this)); }
        if (nav && window.history && window.history.pushState) {
          let stateObj = { nav };
          window.history.pushState(stateObj, "Tips : " + tab + "Desert Landscaping ", nav);
        }

        //log("click",tab);
        // log(App.content.Tips);
        me.activateTab($tab, tab);
      });
    }

    sel = '.action__hide-tab';
    if ($(sel).length) {
      $(sel).off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let tab = $(this).attr("data-tab"),
          $tab = $(".tips-tab-nav-" + tab);
        if (me.showLogs) { log("click hide", tab, $(this)); }
        // log(App.content.Tips);
        me.deactivateTab($tab);
      });
    }

    sel = '.action__tab-nav';
    if ($(sel).length) {
      $(sel).off("click").on("click", function (e) {
        //e.preventDefault();
        //e.stopPropagation();

        if (me.showLogs) { log("click", $(this).attr('data-cat')); }

        log("TODO: verify this is tab");
        // $tab was not defined, define it
        let tab = $(this).attr("data-tab"),
          $tab: any = $(".tips-tab-nav-" + tab);

        if ($('#' + me.footNavSel).length && $tab.selector && $($tab.selector).length) {//&& $('.tips-tab-nav-foot').length 
          $("[class*='tips-tab-nav-']").removeClass('active');
          $($tab.selector).addClass('active');
        }

        let nav = $(this).attr('data-cat');
        if (nav && window.history && window.history.pushState) {
          nav = '/#/' + ROUTES.TIPS + '/' + nav;
          let stateObj = { nav };
          window.history.pushState(stateObj, "Tips : " + $(this).attr('data-cat') + "Desert Landscaping ", nav);
        }
      });
    }

    sel = '.action__tab-nav-foot';
    if ($(sel).length) {
      $(sel).off("click").on("click", function (e) {
        //e.preventDefault();
        //e.stopPropagation();

        // if (me.showLogs) { log("click foot", $(this).attr('data-cat')); }
        let nav = $(this).attr('data-cat');
        if (nav && window.history && window.history.pushState) {
          nav = '/#/' + ROUTES.TIPS + '/' + nav;
          let stateObj = { nav };
          window.history.pushState(stateObj, "Tips : " + $(this).attr('data-cat') + "Desert Landscaping ", nav);
        }
        // open tab
        let $tabsel = $(".tips-tab-nav-" + $(this).attr('data-tab'));
        me.activateTab($tabsel, $(this).attr('data-tab'));
      });
    }

    // MASONRY
    /* function makeMasonry(sel, itemSel, colWidth) {
            if args are undefined, set to the default (tips)
            sel = sel || '.tip-images';
            itemSel = itemSel || '.tip-img';
            colWidth = colWidth || 370; */
    //window.setTimeout(CB.makeMasonry, 600); // moved to activate tab to catch the current tab

    // capture external clicks to new window
    // let externalLinks = $('a[href^="http://"]:not([href^="http://desertlandscaping.arizona"]):not([href^="#"]):not([href^="/"])');
    let externalLinks = $('a[href^="http"]:not([href^="https://desertlandscaping.arizona"]):not([href^="http://localhost"])');
    //info("externalLinks len = %d els: %o",externalLinks.length,externalLinks);
    externalLinks.addClass('external').attr({
      target: "_blank",
      rel: "external"
    });

  }

  public addEventStickySubnavClones() {
    //info("addEventStickySubnavClones");
    let clones = $(".tab-subnav-items.cloned .tip-tab-item-nav-btn");
    if (clones.length) {
      clones.on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let sel = $(this).attr("data-anchor");
        if (sel) {
          sel = sel.replace('#', '');
        }
        sel = ".btn-" + sel;
        //log("click",sel);
        if ($(sel).length) {
          $(sel).first().click();
        } else {
          info("addEventStickySubnavClones > sel not found", sel);
        }
      });
    }

  }

  public updateStickySubnav(sel) {

    let clones = $(".tab-subnav-items.cloned");
    if (this.showLogs) { log("updateStickySubnav", sel); }
    window.setTimeout(() => {
      if (clones.length) {
        clones.remove();
        $(".tab-subnav-items").removeClass("original");
      }
      initStickySubnav(sel);
      this.addEventStickySubnavClones();
    }, 690);//just cuz it's a cool number, needs to be more than 420ish

  }




}
